
import { defineComponent, PropType, provide } from 'vue';
import { useVModel } from 'vue-composable';
import { useStore } from '@/store';
import { Material } from '@/types/app';
import { InjectionKeys } from '@/constants';
import AppModal from '@/components/modal/base/AppModal.vue';

export default defineComponent({
  name: 'MaterialDeleteFormModal',
  emits: ['update:openState'],
  components: {
    AppModal
  },
  props: {
    openState: {
      type: Boolean,
      required: true
    },
    material: {
      type: Object as PropType<Material>
    }
  },
  setup(props) {
    const isOpen = useVModel(props, 'openState');

    const store = useStore();
    const submit = async () => props.material && store.dispatch.materials.delete(props.material);

    provide(InjectionKeys.FormSubmit, submit);

    return {
      isOpen
    };
  }
});
